import type { AuditEntry } from '@domain/types/audit-log';
import dayjs from 'dayjs';

export interface DayGroup {
  label: string;
  entries: AuditEntry[];
}

const localDay = (date: dayjs.ConfigType) => dayjs(date).format('YYYY-MM-DD');

export const groupByDay = (entries: AuditEntry[], now: Date): DayGroup[] => {
  const today = localDay(now);
  const yesterday = localDay(dayjs(now).subtract(1, 'day'));
  const labelFor = (day: string) => {
    if (day === today) return 'Today';
    if (day === yesterday) return 'Yesterday';
    return dayjs(day).format(day.slice(0, 4) === today.slice(0, 4) ? 'D MMMM' : 'D MMMM YYYY');
  };

  const groups: DayGroup[] = [];
  for (const entry of entries) {
    const day = localDay(entry.created_at);
    const last = groups[groups.length - 1];
    if (last && localDay(last.entries[0].created_at) === day) last.entries.push(entry);
    else groups.push({ label: labelFor(day), entries: [entry] });
  }
  return groups;
};
